@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

@if (autoSaveLoading) {
  <div class="autosave-icon-fixed">
    <mat-icon class="blink">cloud_upload</mat-icon>
  </div>
}

@if (survey) {
  <div class="row" style="background-color: #F1F2F2">
    <div class="container mt-3" style="background-color: #F1F2F2">
      @if (survey?.answered && !justSubmitted) {
        <div class="alert alert-info my-3 text-center" role="alert">
          {{ (answerStatus == 'SENT' ? "generic.questionnaire-sent" : "components.responses.info-draft-date") | translate
          }}. <br>@if (answerTimestamp) {
          <span>
          {{'components.responses.info-sent-date' | translate}} {{ answerTimestamp | formatdate | date:'short'}}</span>
        }
      </div>
    }
    @if ((!survey?.answered && !impersonateEmail) || justSubmitted) {
      <mat-stepper [linear]="true" #stepper
        style="background-color: #F1F2F2">
        <!-- Anagraphic Form Template -->
        <ng-template #anagraphicFormContent>
          <form [formGroup]="userInfoForm">
            <div class="box flex-column my-0 pb-0 pt-3 px-3 border-0">
              <mat-form-field appearance="fill">
                <mat-label>{{ "generic.name" | translate }}</mat-label>
                <input formControlName="first_name" [(ngModel)]="survey.user.first_name"
                  [required]="survey.customs?.anagraphic_is_mandatory !== false" matInput>
              </mat-form-field>
            </div>
            <div class="box flex-column my-0 pb-0 pt-3 px-3 border-0">
              <mat-form-field appearance="fill">
                <mat-label>{{ "generic.surname" | translate }}</mat-label>
                <input formControlName="last_name" [(ngModel)]="survey.user.last_name"
                  [required]="survey.customs?.anagraphic_is_mandatory !== false" matInput>
              </mat-form-field>
            </div>
            <div class="box flex-column my-0 pb-0 pt-3 px-3 border-0">
              <mat-form-field appearance="fill">
                <mat-label>{{ "generic.phone" | translate }}</mat-label>
                <input formControlName="phone_number" [(ngModel)]="survey.user.phone_number" matInput>
              </mat-form-field>
            </div>
            <div class="box flex-column my-0 pb-0 pt-3 px-3 border-0">
              <mat-form-field appearance="fill">
                <mat-label>{{ "generic.email" | translate }}</mat-label>
                <input type="email" [email]="true" [(ngModel)]="survey.user.email" formControlName="email"
                  [required]="survey.customs?.anagraphic_is_mandatory !== false" matInput>
              </mat-form-field>
            </div>

            @for (field of survey.team_member_custom_fields; track field.id) {
              @if (field.visible) {
                <div class="box flex-column my-0 pb-0 pt-3 px-3 border-0">
                  <mat-form-field appearance="fill">
                    <mat-label>{{ field.name }}</mat-label>
                    @switch (field.type) {
                      @case ('number') {
                        <input type="number" [formControlName]="field.id" [(ngModel)]="survey.user.custom_fields[field.id]" matInput>
                      }
                      @case ('date') {
                        <input type="date" [formControlName]="field.id" [(ngModel)]="survey.user.custom_fields[field.id]" matInput>
                      }
                      @case ('boolean') {
                         <mat-select [formControlName]="field.id" [(ngModel)]="survey.user.custom_fields[field.id]">
                            <mat-option [value]="true">{{ 'generic.yes' | translate }}</mat-option>
                            <mat-option [value]="false">{{ 'generic.no' | translate }}</mat-option>
                         </mat-select>
                      }
                      @default {
                        <input type="text" [formControlName]="field.id" [(ngModel)]="survey.user.custom_fields[field.id]" matInput>
                      }
                    }
                  </mat-form-field>
                </div>
              }
            }
          </form>
        </ng-template>
        <!-- START: Anagraphic Form Step -->
        @if (shouldShowAnagraphicAt('START')) {
          <mat-step [stepControl]="userInfoForm">
            <ng-template matStepLabel>{{ "generic.generic-info" | translate }}</ng-template>
            <div class="mt-5">
              <ng-container *ngTemplateOutlet="anagraphicFormContent"></ng-container>
            </div>
            <div class="row justify-content-end mt-5 mx-1">
              <button class="btn-custom border-0 d-flex align-items-center px-5 py-2" matStepperNext>
                <mat-icon class="mr-2">play_circle_outlined</mat-icon>
                {{'generic.next' | translate}}
              </button>
            </div>
          </mat-step>
        }
        <!-- Intro Step -->
        @if (!survey?.customs?.skip_introduction) {
          <mat-step>
            <div class="mt-4">
              <ng-template matStepLabel>{{ "generic.introduction" | translate }}</ng-template>
              <p class="label-box font-weight-bold">{{ "components.decision-table.new-decision-table.compile-proposal.title"
              | translate}}</p>
              <p>{{ survey?.title }}</p>
              @if (survey.description) {
                <p class="label-box font-weight-bold mt-4">{{ "generic.description" | translate}}</p>
                <p class="preserve-whitespace">{{ survey?.description }}</p>
              }
              @if (survey?.attachments?.length > 0) {
                <app-attachments-list [attachments]="survey?.attachments" />
              }
              <div class="row justify-content-end mt-3">
                <button class="btn-custom border-0 d-flex align-items-center px-5 py-2" matStepperNext>
                  <mat-icon class="mr-2">play_circle_outlined</mat-icon>
                  {{'generic.next' | translate}}
                </button>
              </div>
            </div>
          </mat-step>
        }
        <!-- Questions Step -->
        <mat-step [label]="'generic.questions' | translate" [completed]="isQuestionsValid">
          <div>
            <div class="mt-5">
              <app-survey-details [surveyObj]="survey" [isResponse]="true" />
            </div>
            @if (loading) {
              <div class="row my-5">
                <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
              </div>
            }
            <div class="row justify-content-between mt-3">
              <button [disabled]="loading" mat-stroked-button
                class="text-dark-purple border-purple back-btn-stroked d-flex align-items-center"
                matStepperPrevious>
                {{'generic.back' | translate}}
              </button>
              @if (survey?.customs?.draft_answer_is_enabled) {
                <button [disabled]="loading"
                  class="btn-custom border-0 d-flex align-items-center px-5 py-2 ml-auto mr-3"
                  (click)="!loading ? onSubmit(true) : ''">
                  {{'generic.buttons.save-draft' | translate}}
                </button>
              }
              <!-- Submit Button (if Anagraphic is START or PRIVATE) -->
              @if (shouldShowAnagraphicAt('START') || survey.visibility_type === 'PRIVATE') {
                <button [disabled]="loading"
                  class="btn-custom border-0 d-flex align-items-center px-5 py-2" (click)="!loading ? onSubmit() : ''">
                  <mat-icon class="mr-2">play_circle_outlined</mat-icon>
                  {{'generic.buttons.save-and-send' | translate}}
                </button>
              } @else {
                <!-- Next Button (if Anagraphic is END) -->
                <button
                  class="btn-custom border-0 d-flex align-items-center px-5 py-2"
                  (click)="validateQuestionsAndProceed(stepper)">
                  <mat-icon class="mr-2">play_circle_outlined</mat-icon>
                  {{'generic.next' | translate}}
                </button>
              }
            </div>
          </div>
        </mat-step>
        <!-- END: Anagraphic Form Step -->
        @if (shouldShowAnagraphicAt('END')) {
          <mat-step [stepControl]="userInfoForm">
            <ng-template matStepLabel>{{ "generic.generic-info" | translate }}</ng-template>
            <div class="mt-5">
              <ng-container *ngTemplateOutlet="anagraphicFormContent"></ng-container>
            </div>
            <div class="row justify-content-between mt-5 mx-1">
              <button mat-stroked-button
                class="text-dark-purple border-purple back-btn-stroked d-flex align-items-center"
                matStepperPrevious>
                {{'generic.back' | translate}}
              </button>
              <button [disabled]="loading" class="btn-custom border-0 d-flex align-items-center px-5 py-2"
                (click)="!loading ? onSubmit() : ''">
                <mat-icon class="mr-2">play_circle_outlined</mat-icon>
                {{'generic.buttons.save-and-send' | translate}}
              </button>
            </div>
          </mat-step>
        }
        <mat-step>
          <ng-template matStepLabel>{{ 'generic.done' | translate }}</ng-template>
          <div class="col-12 text-center d-flex flex-column align-items-center py-4">
            <img src="assets/img/all-sent.png" alt="" class="all-sent-img mb-3">
            <h4 class="font-weight-bold col-12 w-100 pl-0 mt-3 text-center color-primary-purple">
              {{ 'pages.surveys.response.submitted-successfully' | translate }}
            </h4>
          </div>
        </mat-step>
      </mat-stepper>
    }
    @if (survey?.answered && !justSubmitted) {
      <app-survey-details [surveyObj]="survey" [isResponse]="true" />
    }
  </div>
</div>
}
